import { PageController } from '@client/components/_core/layout/PageController';
import { ThirdPartyContactTypeEdit } from '@client/components/claims/product-types/ThirdPartyContactEdit';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/third-party-contact-type/edit/$thirdPartyContactTypeId',
)({
    staticData: {
        presentation: 'overlay',
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <ThirdPartyContactTypeEdit action={['edit', Route.useParams().thirdPartyContactTypeId]} />
        </PageController>
    );
}
